<template>
    <div>
        <h5>{{ name }}</h5>
        <button v-for="option in options" type="button" class="btn btn-secondary btn-lg options"
                @click="clicked(option)"
                v-bind:class="{ active: isActive(option) }">{{ option.value }}
        </button>
    </div>
</template>

<script>
    export default {
        props: ['name', 'options', 'currentProductId'],

        methods: {

            clicked(option) {
                if (!this.isActive(option)) {
                    window.location.href = option.url;
                }
            },

            isActive(option) {
                return (option.product_id == this.currentProductId);
            }

        }
    }
</script>
